<template>
  <div class="tw-flex tw-flex-col tw-items-start tw-justify-center">
    <WdsText size="sm" weight="medium">{{ isValid ? payrolledAt : '--' }}</WdsText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const PaymentRequestPayrolledAtColumn = graphql(`
  fragment PaymentRequestPayrolledAtColumn on PaymentRequest {
    id
    payrolledAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestPayrolledAtColumn>
}>()

const column = computed(() => useFragment(PaymentRequestPayrolledAtColumn, props.row))

const { date: payrolledAt, isValid } = useDate(column.value.payrolledAt)
</script>

<style scoped></style>
